import React from 'react';
import { Card, CardContent, CardMedia } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import News from "./News";

import newsList from "../data/news.json";

//  https://undraw.co/illustrations
import CalendarImage from '../content/calendar.png';

const useStyles = makeStyles((theme) => ({
  card: {
    margin: '16px 0px',
  },
  cardMedia: {
    float: 'right',
    width: '30% !important',
  },
  subtitle: {
    marginTop: theme.spacing(1),
  },
  title:{
    marginTop: theme.spacing(3)
  }
}));

function Home() {
  const classes = useStyles();

  let today = Date.now();
  const currentNews = newsList.filter(item => (Date.parse(item.startDisplay) <= today && Date.parse(item.endDisplay) >= today))
  
  return (
        <Card className={classes.card}>
          <CardMedia component="img" className={classes.cardMedia} image={CalendarImage} />
          <CardContent>
            <Typography variant="h4">Welcome to Vacation Bidding for Flight Attendants!</Typography>
            <Typography variant="h6" className={classes.subtitle}>Set your bids. See your awards!</Typography>
            {currentNews.length > 0 && (
              <Typography variant="h5" className={classes.title}>What's new</Typography>
            )}
            {currentNews.map((itm, idx) =>{
              return <News key={idx} item={itm}/>
            })}
          </CardContent>
        </Card>
  )
}

export default Home;